<template>
  <div class="guanLianBox">
    <el-dialog title="导出月账单" :visible.sync="MonthVisible" width="40%" :close-on-click-modal="false" center>
      <div>
        <el-form label-width="120px" :rules="rules" :inline="true" :model="monthForm" class="demo-form-inline" ref="monthForm">
          <el-form-item label="导出月份:" prop="daochuMonth">
            <el-date-picker :picker-options="setMonthDisabled" size="mini" style="width:150px" value-format="yyyy-MM" v-model="monthForm.daochuMonth" type="month" placeholder="导出月份" @change='chengeMonth' :clearable="false" :editable="false">
            </el-date-picker>
          </el-form-item>
          <div>
            <el-form-item label="账单时间:" prop="billTimeStart">
              <el-date-picker :disabled="true" v-model="monthForm.billTimeStart" size="mini" type="date" style="width:150px" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker> <span style="margin:0 10px;">~</span>
            </el-form-item>

            <el-form-item prop="billTimeEnd">
              <el-date-picker :disabled="true" v-model="monthForm.billTimeEnd" size="mini" type="date" style="width:150px" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
            </el-form-item>
          </div>

        </el-form>

      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="monthNo">取 消</el-button>
        <el-button type="primary" @click="monthOK('monthForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { exportExcel } from '@/utils/fileDown.js'

export default {
  name: 'addDialog',
  data () {
    return {
      setMonthDisabled: {
        disabledDate (time) {
          // 获取当前的月份信息
          const date = new Date() // 获取当前的时间基本信息，值是这样的： Tue Jul 20 2021 14:59:43 GMT+0800 (中国标准时间)
          const year = date.getFullYear() // 获取当前年份，值是这样的： 2021
          let month = date.getMonth() + 1 // 获取当前月份，值是这样的： 6   getMonth()方法返回值是0-11，也就是1月份到12月份，所以要加上1，才是当前月份
          if (month >= 1 && month <= 9) {
            // 如果是1月到9月就要在前面补上一个0   比如：02、07    月份这样表示
            month = '0' + month
          }
          const nowDate = year.toString() + month
            .toString() // 转换成字符串拼接，最终得到年和月，比如此时的时间是2021年7月20号，所以nowDate的值是：202107

          // 获取时间选择器的月份信息
          const timeyear = time.getFullYear() // 获取时间选择器的年份（有很多）
          let timemonth = time.getMonth() + 1 // 与上面同理
          if (timemonth >= 1 && timemonth <= 9) {
            timemonth = '0' + timemonth
          }
          const elTimeData = timeyear.toString() + timemonth.toString()

          // 返回，时间选择器的日期月份大于当前日期的月份，又因为disabledDate函数是控制月份禁用不可选
          // 所以，最终就是：时间选择器的月份大于当前的月份，就都禁用掉，所以就实现了最终效果：
          // 大于等于当前月份都不可选
          return elTimeData >= nowDate // 这里虽然是字符串，但是弱类型语言js会做一个转换，是可以比较大小的如： '202107' > '202008'
        }
      },
      monthForm: {},
      rules: {
        daochuMonth: [{
          required: true,
          message: '请选择导出月份',
          trigger: 'change'
        }]
      }
    }
  },
  props: {
    titleFlag: {
      type: String
    },
    MonthVisible: {
      type: Boolean,
      default: false
    }
  },

  created () {
    this.getTMonthlyStatementConfigS()
  },
  mounted () { },
  methods: {
    chengeMonth () {
      this.getTMonthlyStatementConfigS()
    },
    getTMonthlyStatementConfigS () {
      let year, month, t2, str2

      if (this.monthForm.daochuMonth && this.monthForm.daochuMonth !== '') {
        let arr = this.monthForm.daochuMonth.split('-')
        year = arr[0] // 获取当前日期的年份
        month = arr[1] // 获取当前日期的月份
        t2 = year + '-' + month + '-'
      } else {
        const arr = new Date().toLocaleDateString().split('/')
        year = arr[0] // 获取当前日期的年份
        month = arr[1] // 获取当前日期的月份
        month = parseInt(month) - 1
        if (month == 0) {
          year = parseInt(year) - 1
          month = 12
        }
        t2 = year + '-' + month.toString().padStart(2, 0) + '-'
      }
      str2 = new Date(year, month, 0).getDate()
      this.$set(this.monthForm, 'daochuMonth', t2)
      this.$set(this.monthForm, 'billTimeStart', t2 + '01')
      this.$set(this.monthForm, 'billTimeEnd', t2 + str2)
    },
    monthNo () {
      this.$emit('update:MonthVisible', false)
    },
    monthOK (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var a = (new Date(this.monthForm.billTimeStart)).getTime()
          var b = (new Date(this.monthForm.billTimeEnd)).getTime()
          if (a > b) {
            this.$message.error('结束时间不能小于开始时间')
          } else {
            exportExcel(
              this.global.wmsStockName + '/tEmptyForJanFaCharge/exportMonthYycFeeList', {
              billTimeStart: this.monthForm.billTimeStart,
              billTimeEnd: this.monthForm.billTimeEnd
            },
              '月账单表'
            )
            this.$emit('update:MonthVisible', false)
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }

  }

}

</script>

<style lang="less" scoped>
/deep/ .el-form-item {
  margin: 0px;
}
</style>
